const state = {
  requestLog: [],
  error: '',
  errorMessage: undefined,
  errorCode: undefined,
  isReferralFlow: undefined,
  isUpdateMobileNoFocusBlur: undefined,
  tokenData: undefined,
};
export default state;
